
import React from 'react';

import Grid from '@mui/material/Grid2';
import { ModelBase, PlayerObject } from "@models";
import { SourceBook } from "@dndModels";

import NonFSIndex from "@dndComponents/NonFSIndex";

import API from "@dndUtilities/system_api";

const api = API.getInstance();

export default function SourceBookIndex() {
  return (
    <Grid container spacing={0} direction="row">
      <Grid size={12}>
        <NonFSIndex
          data_type="source_book"
          // log_it
          quick_fields={["source_book_type","public","third_party","ua","owned","shared"]}
          // extra={(obj) => {
          //   if (obj instanceof SourceBook && api.user) {
          //     if (api.user._id === obj.owner_id) {
          //       return <span>(Owner)</span>;
          //     } else if (obj.is_free) {
          //       return <span>(Free)</span>;
          //     } else if (api.user.purchased_sb_ids.includes(obj._id)) {
          //       return <span>(Purchased)</span>;
          //     } else {
          //       return <span>(Not Purchased)</span>;
          //     }
          //   }
          //   return <></>;
          // }}
        />
      </Grid>
    </Grid>
  );
}
